import React, { useState } from "react";
import Loader from "../../components/styled-components/loader/loader";
import { Button } from "../../components/button/Button";
import { Input } from "../../components/input/Input";
import { InputGroup } from "../../components/inputGroup/InputGroup";
import Base64 from "../../utils/base64";
import axios from "axios";
import ROUTES from "../../config/routes";
import swal from "sweetalert";

export const ForgetOtp = (props) => {
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleOTP();
    }
  };
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const result = event.target.value.replace(/\D/g, "");
    setUserData({ ...userData, [name]: result });
  };
  const handleOTP = async () => {
    if (userData && userData.otp) {
      props.otpState(userData.otp);
      props.stepState(4);
    } else {
      swal(
        "Oops!",
        userData && !userData.otp && "Please enter a valid OTP",
        "error"
      );
    }
  };
  const handleResendOtp = async () => {
    if (props.selectedType && props.selectedType) {
      const payload = {
        type: props.selectedType && props.selectedType,
        userName: props && props.data && props.data.userName,
      };
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/send-otp`,
          payload,
          config
        );
        setLoading(false);
        if (res.status === 200 && res.data) {
          swal("Success", res.data.message, "success");
        }
      } catch (error) {
        setLoading(false);
        swal(
          "Oops!",
          error.response && error.response.data && error.response.data.message,
          "error"
        );
      }
    } else {
      swal("Oops!", "Please Select Phone or Email to Recieve OTP ", "error");
    }
  };
  return (
    <div style={{ marginTop: "20px" }}>
      <div className="login-card border">
        <h2 className="login-heading">Forgot Password</h2>
        <p 
          style={{
            color: "rgb(77, 94, 128)",
            fontFamily: "Poppins",
            textAlign: "left",
          }}
        >
          Enter One-Time Code that was sent to you by text or email
        </p>
        <div>
          <InputGroup>
            <label>Enter OTP</label>
            <Input
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              value={userData && userData.otp}
              id="otp"
              type="text"
              placeholder="***OTP***"
              name="otp"
              maxLength={6}
            ></Input>
          </InputGroup>
          <span
            style={{
              color: "#2A3DA3",
              cursor: "pointer",
              float: "right",
              marginBottom: "8px",
            }}
            onClick={() => {
              handleResendOtp();
            }}
          >
            Resend OTP
          </span>
          <Button
            style={{ background: "#2A3DA3" }}
            onClick={() => {
              handleOTP();
            }}
          >
            Next
          </Button>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
            }}
          ></div>
        </div>
      </div>
      <Loader isLoading={loading}></Loader>
    </div>
  );
};
